export class ACOVPItem {
	/**
	 *item number
	 */
	public sItemNo: string;
	/**
	 *item count
	 */
	public iCnt: number;
	constructor(public list: any) {
	}
}